import { render } from "./SectionSecteur.vue?vue&type=template&id=4fd5d3b1&scoped=true"
import script from "./SectionSecteur.vue?vue&type=script&lang=js"
export * from "./SectionSecteur.vue?vue&type=script&lang=js"

import "./SectionSecteur.vue?vue&type=style&index=0&id=4fd5d3b1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd5d3b1"]])

export default __exports__